import useHelpers from "../../../helpers";
import useStrings from "../../../strings";
import useInitialStates from "../../initialStates";

const useRoleReducers = () => {
  // Helpers
  const { useCreateReducer } = useHelpers();
  const { createReducer } = useCreateReducer();

  // Strings
  const { useTypes } = useStrings();
  const { useRolesTypes } = useTypes();
  const { ADD_ROLE, REMOVE_ROLE } = useRolesTypes();

  // State
  const { useRoleInitialStates } = useInitialStates();
  const { roleInitialState } = useRoleInitialStates();

  const roleSelected = createReducer(roleInitialState, {
    [ADD_ROLE](state, action) {
      const { payload } = action;
      return payload;
    },
    [REMOVE_ROLE]() {
      return roleInitialState;
    },
  });

  return {
    roleSelected,
  };
};

export default useRoleReducers;
